module.exports = __webpack_public_path__ + "img/Mapi.76e0deae.png";